import { Box } from '@mui/material';

const DetailsRowsVolet1 = () => {
  return (
    <Box className="flex flex-col w-[max-content]">
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Une concertation politique et civique s’engage efficacement dans la lutte contre le
          changement climatique et la préservation des ressources naturelles en adoptant une
          approche fondée sur l’égalité des genres et des droits humains
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          1.1
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de nouvelles séries statistiques et d'indicateurs environnementaux disponibles et
          pérennes
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Documents des politiques et stratégies, rapports nationaux, OTEDD « Les indicateurs du
          Développement Durable » (2027)
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          1.2
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de politiques publiques développées ou révisées à travers des concertations des
          diverses parties prenantes (IPA PF 2.11)
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Documents des politiques et stratégies, rapports nationaux
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Documents des politiques et stratégies, rapports nationaux{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Le cadre législatif, réglementaire et normatif en matière d’environnement et de lutte
          contre le changement climatique est adapté, sensible au genre et/ou mis en application
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          1.1.1
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de propositions d’évolution réglementaire visant à mettre en œuvre les engagements
          de l’Accord de Paris (IPA PF 3.33){' '}
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Documents réglementaires, Projets de lois de modifications réglementaires consultables sur
          le site Jurisite Tunisie www. jurisitetunisie.com/index.html{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          1.1.2
        </div>
        <div className="w-[220px] font-bold  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre d’instruments adoptés en faveur de l’économie verte
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports nationaux
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          1.1.3
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de secteurs couverts par une information environnementale disponible au public{' '}
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports sectoriels, Rapport annuel sur l'état de l'environnement de OTEDD.{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Des actions de sensibilisation des citoyens, des organisations de la société civile, des
          organisations professionnelles agricoles et des entreprises sont mises en œuvre et
          contribuent à la prise de décision pour une gestion de l’environnement inclusive qui tient
          compte de l'égalité de genre et les droits humains
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          1.2.1
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre d’étudiants sensibilisés à une consommation durable{' '}
          <span className="text-green-500">(désagrégés par genre, âge)</span>
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Collecte et analyse de données, rapports de projet{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          1.2.2
        </div>
        <div className="w-[220px] font-bold  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre d´activités de sensibilisation des consommateurs
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de projet{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          La Société Civile contribue à l’action environnementale
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          1.2.3
        </div>
        <div className="w-[220px] font-bold text-red-500 flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre d’entreprises engagées dans des campagnes encourageant une consommation plus
          durable{' '}
        </div>
        <div className="w-[280px] font-bold  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l'opérateur; rapports budgétaires et/ou financiers nationaux{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l'opérateur; rapports budgétaires et/ou financiers nationaux{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Appuyer le MinEnv dans l’élaboration, l’actualisation, et la mise en œuvre inclusive des
          instruments de politique publique en matière d’environnement et de climat{' '}
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Appuyer la mise en place ou l’opérationnalisation de mécanismes et instruments pour la
          mise en œuvre de la Stratégie nationale de transition écologique
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Appuyer la modernisation des systèmes existants pour la collecte et diffusion de données
          environnementales et climatiques
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Promouvoir l’éducation environnementale dans les systèmes scolaire et universitaire
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Promouvoir une communication sensible au genre sur l’environnement, le changement
          climatique et la consommation durable{' '}
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Renforcer les capacités des médias à traiter les questions environnementales et
          climatiques
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Renforcer les capacités de plaidoyer environnemental des acteurs-trices de la société
          civile
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Renforcer la participation de la société civile dans les processus décisionnels en lien
          avec l’environnement et le climat
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          n.a
        </div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          (activité , pas de SdV){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Renforcer les capacités des organismes de la société civile dans leurs actions de
          sensibilisation environnementale
        </div>
      </div>
    </Box>
  );
};

export default DetailsRowsVolet1;
